window.initializeSwiperWhenVisible('.block__article-grid-row', () => {
  new Swiper('.block__article-grid-row', {
    slidesPerView: 4,
    paginationClickable: false,
    loopAdditionalSlides: 2,
    spaceBetween: 10,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      749: {
        slidesPerView: 2,
        loop: true,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1,
        loop: true,
        loopAdditionalSlides: 1,
        initialSlide: 1,
        spaceBetween: 20,
      },
    },
  });
});
